<div class="display-none">
  Client Sync Status
  <hr />
  <tcs-pubnub-details></tcs-pubnub-details>
</div>
